<div class="task-revision-wrapper row">
  <div class="configuration col-xs-12 col-sm-12 col-md-4">
    <div class="padder">
      <h3 class="title" i18n="task revision component title|The title of the task revision component shown to authenticated users@@taskRevisionComponentTitle">Configuration</h3>
      <div class="input-group row">
        <label class="col-4" i18n="task revision task name entry label|The label before the input describing the Task Name of the current task name@@taskNameLabelTaskRevision">Task Name</label>
        <input type="text" class="form-control col-8" [value]="task.name" readonly>
      </div>
      <div class="input-group row">
        <label class="col-4" i18n="task revision workspace entry label|The label before the input describing the Workspace of the current task@@workspaceLabelTaskRevision">Workspace</label>
        <input type="text" class="form-control col-8" [value]="task.PBIWorkspaceId" readonly>
      </div>
      <div class="input-group row">
        <label class="col-4" i18n="task revision report entry label|The label before the input describing the Report of the current task@@reportLabelTaskRevision">Report</label>
        <input type="text" class="form-control col-8" [value]="task.PBIReportName" readonly>
      </div>
      <div class="input-group row" *ngIf="task.pages !== undefined">
        <label class="col-4" i18n="task revision pages entry label|The label before the input describing the Pages of the current task@@pagesLabelTaskRevision">Pages</label>
        <textarea
          type="text"
          class="form-control col-8"
          [rows]="getTaskPageArray().length + 1"
          [value]="getTaskPageArray().join(',\n')"
          readonly
        ></textarea>
      </div>
    </div>
  </div>
  <div class="deliveries col-xs-12 col-sm-12 col-md-4">
    <div class="padder">
      <h3 class="title">
        <span style="margin-right: 5px" class="quantity">{{ task.deliveryContacts.length + " " }}</span>
        <span
          *ngIf="task.deliveryContacts.length === 1"
          i18n="delivery sufix after the number of deliveries singular|The label after the number one indicating that there's a single delivery in a task at task revision@@deliverySufixAfterNumberTaskRevision"
        >Delivery</span>
        <span
          *ngIf="task.deliveryContacts.length !== 1"
          i18n="delivery sufix after the number of deliveries plural|The label after the number of deliveries in a task at task revision@@deliverySufixAfterNumberTaskRevision"
        >Deliveries</span>
      </h3>
      <div class="lister">
        <div class="delivery" *ngFor="let delivery of task.deliveryContacts; index as i">
          <hr />
          <h4 class="list-title" i18n="delivery with code to help identify each delivery at task revision@@deliveryStringAndNumberTaskRevision">Delivery # {{ i + 1 }}</h4>
          <div class="input-group row">
            <label class="col-4" i18n="label of subject of delivery on task revision@@labelSubjectofDeliveryOnTaskRevision">Subject</label>
            <input type="text" class="form-control col-8" [value]="delivery.subject" readonly>
          </div>
          <div class="input-group row">
            <label class="col-4" i18n="label of contact of delivery on task revision@@labelContactofDeliveryOnTaskRevision">Contacts</label>
            <textarea type="text" [rows]="delivery.contactId.length" class="form-control col-8" [value]="getContactNames(delivery.contactId).join('\n')" readonly></textarea>
          </div>
          <div class="input-group row">
            <label class="col-4">Tags</label>
            <textarea type="text" class="form-control col-8" [value]="delivery.tags" readonly></textarea>
          </div>
          <div class="input-group row">
            <label class="col-4" i18n="label of filters of delivery on task revision@@labelFiltersofDeliveryOnTaskRevision">Filters</label>
            <textarea type="text" [rows]="getFilterLabel(delivery).length + 1" class="form-control col-8" [value]="getFilterLabel(delivery).join('\n')" readonly></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="schedules col-xs-12 col-sm-12 col-md-4">
    <div class="padder">
      <h3 class="title">
        <span style="margin-right: 5px" class="quantity">{{ task.schedules.length + " " }}</span>
        <span
          *ngIf="task.schedules.length === 1"
          i18n="schedule sufix after the number of deliveries singular|The label after the number one indicating that there's a single delivery in a task at task revision@@singularScheduleSufixAfterNumberTaskRevision"
        >Schedule</span>
        <span
          *ngIf="task.schedules.length !== 1"
          i18n="schedule sufix after the number of deliveries plural|The label after the number of deliveries in a task at task revision when it is plural@@pluralScheduleSufixAfterNumberTaskRevision"
        >Schedules</span>
      </h3>
      <div class="lister">
        <div class="schedule" *ngFor="let schedule of task.schedules; index as i">
          <hr />
          <h4 class="list-title" i18n="schedule with code to help identify each schedule at task revision@@scheduleStringAndNumberTaskRevision">Schedule # {{ i + 1 }}</h4>
          <div class="input-group row">
            <label class="col-4" i18n="label of type of schedule on task revision@@labelTypeOfScheduleOnTaskRevision">Type</label>
            <input type="text" class="form-control col-8" [value]="getTypeLabel(schedule)" readonly>
          </div>
          <div class="input-group row">
            <label class="col-4" i18n="label of rule of schedule on task revision@@labelRuleOfScheduleOnTaskRevision">Rule</label>
            <input type="text" class="form-control col-8" [value]="getRuleLabel(schedule)" readonly>
          </div>
          <div class="input-group row">
            <label class="col-4" i18n="label of local time of schedule on task revision@@labelLocalTimeOfScheduleOnTaskRevision">Local Time</label>
            <input type="text" class="form-control col-8" [value]="getScheduleLocalTime(schedule)" readonly>
          </div>
          <div class="input-group row">
            <label class="col-4" i18n="label of status of schedule on task revision@@labelStatusOfScheduleOnTaskRevision">Status</label>
            <input type="text" class="form-control col-8" [value]="schedule.status === 'A' ? 'Enabled' : 'Disabled'" readonly>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
